import React, { useEffect, useState } from 'react'
import Graytextarea from '../../../src/components/Graytextarea'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import toast from 'react-hot-toast'

const PatientAlerts = ({ noteStructureRef, diagnosisName, showTreatmentAsAccordion }) => {
  const [value, setValue] = useState('')
  const [visible, setVisible] = useState(false)
  const [tempValue, setTempValue] = useState('')

  console.log('value',value,showTreatmentAsAccordion)
  useEffect(() => {
    const alertValue = noteStructureRef?.current?.alertData?.[diagnosisName] || ''
    setValue(alertValue)
    setTempValue(alertValue)
  }, [diagnosisName])

  const handleSave = () => {
    setValue(tempValue)

    if (noteStructureRef?.current) {
      if (!noteStructureRef.current.alertData) {
        noteStructureRef.current.alertData = {}
      }

      noteStructureRef.current.alertData[diagnosisName] = tempValue
    }

    setVisible(false)
    toast.success('Alert saved')
  }

  return (
    <>
          {showTreatmentAsAccordion ? (
          
          <div style={{ marginLeft: '' }}>
            <div className="mt-2 d-flex gap-3 align-items-center">
              <h7>
                <b>Alert</b>
              </h7>
            </div>
            <hr />
            {value && (
              <div className="px-2">
                <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                  {value}
                </div>
              </div>
            )}
          </div>
          )
        : (
          <div style={{ marginLeft: '' }}>
            <div className="mt-2 d-flex gap-3 align-items-center">
              <h7>
                <b>Alert</b>
              </h7>           
            
            </div>
            <hr /> 
          
            <div>
              <Graytextarea height="20px" value={value}             onClick={() => setVisible(true)}
 />
             </div>
          </div>             
        
        )}
     

      {/* Modal */}
      <CModal backdrop="static" visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
         <CModalTitle>{value ? 'Edit Alert' : 'Add Alert'}</CModalTitle>
        </CModalHeader>

        <CModalBody>
          <Graytextarea
            height="100px"
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
          />
        </CModalBody>

        <CModalFooter>
          <CButton  variant="outline" color="secondary" onClick={() => setVisible(false)}>
            Cancel
          </CButton>
          <CButton color="primary" onClick={handleSave}>
             Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )

   
}

export default PatientAlerts